import { Controller } from "@hotwired/stimulus"

// Names the customer, company and amount in the confirmation before the invoice is sent.
export default class extends Controller {
  static targets = ["customer", "company", "amount", "currency"]
  static values = { message: String, defaultCompany: String }

  update() {
    const company = this.companyTarget.selectedOptions[0]?.text || this.defaultCompanyValue
    this.element.dataset.turboConfirm = this.messageValue
      .replace("__CUSTOMER__", () => this.customerTarget.value.trim())
      .replace("__COMPANY__", () => company)
      .replace("__AMOUNT__", () => this.amountTarget.value.trim())
      .replace("__CURRENCY__", () => this.currencyTarget.value)
  }
}
